var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70508 15.3955C7.70508 15.1966 7.7841 15.0058 7.92475 14.8652C8.0654 14.7245 8.25617 14.6455 8.45508 14.6455H15.2051V7.89551C15.2051 7.6966 15.2841 7.50583 15.4247 7.36518C15.5654 7.22453 15.7562 7.14551 15.9551 7.14551C16.154 7.14551 16.3448 7.22453 16.4854 7.36518C16.6261 7.50583 16.7051 7.6966 16.7051 7.89551V14.6455H23.4551C23.654 14.6455 23.8448 14.7245 23.9854 14.8652C24.1261 15.0058 24.2051 15.1966 24.2051 15.3955C24.2051 15.5944 24.1261 15.7852 23.9854 15.9258C23.8448 16.0665 23.654 16.1455 23.4551 16.1455H16.7051V22.8955C16.7051 23.0944 16.6261 23.2852 16.4854 23.4258C16.3448 23.5665 16.154 23.6455 15.9551 23.6455C15.7562 23.6455 15.5654 23.5665 15.4247 23.4258C15.2841 23.2852 15.2051 23.0944 15.2051 22.8955V16.1455H8.45508C8.25617 16.1455 8.0654 16.0665 7.92475 15.9258C7.7841 15.7852 7.70508 15.5944 7.70508 15.3955Z",
    fill: "#212529"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9551 30.3955C24.2396 30.3955 30.9551 23.68 30.9551 15.3955C30.9551 7.11101 24.2396 0.395508 15.9551 0.395508C7.67058 0.395508 0.955078 7.11101 0.955078 15.3955C0.955078 23.68 7.67058 30.3955 15.9551 30.3955ZM15.9551 28.8955C23.4108 28.8955 29.4551 22.8513 29.4551 15.3955C29.4551 7.93976 23.4108 1.89551 15.9551 1.89551C8.49933 1.89551 2.45508 7.93976 2.45508 15.3955C2.45508 22.8513 8.49933 28.8955 15.9551 28.8955Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/PlusIcon.7c443abefc37bbd321a318e18baffec9.svg";
export { ForwardRef as ReactComponent };